import * as React from "react";
import { FaAddressCard } from "react-icons/fa";
const SvgComponent = ({width ,height, bg = "transparent", color = "var(--filter-bar-btn-border)", stroke = "var(--filter-bar-btn-border)", opacity, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 30 30"
    fill={bg}
    width={width}
    height={height}
    {...props}
  >
    <rect x={0.5} y={0.5} width={29} height={29} rx={5.5} stroke={stroke} />
    <g transform="translate(6,6)">
      <FaAddressCard
        style={{
          fontSize: "16px",
          fill: color,
          opacity: opacity,
        }}
      />
    </g>
  </svg>
);

export default SvgComponent;
